export default __webpack_public_path__ + "static/media/second.dc3d4ec7.jpg";